var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Toggle', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var onClick = _ref.onClick,
            isActive = _ref.isActive;
        return [_c('div', {
          staticClass: "quick-order product-price-block__button",
          class: [{
            'quick-order_active': isActive
          }]
        }, [_c('button', {
          staticClass: "quick-order__button",
          attrs: {
            "data-e2e": "quick-order-button"
          },
          on: {
            "click": onClick
          }
        }, [_vm._v("\n        Быстрое оформление\n      ")]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: isActive,
            expression: "isActive"
          }],
          staticClass: "quick-order__form"
        }, [_c('div', {
          staticClass: "p mb-10"
        }, [_vm._v("\n          Оставьте телефон, оператор перезвонит в течении 5 минут и уточнит детали.\n        ")]), _vm._v(" "), _c('ValidationObserver', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var handleSubmit = _ref2.handleSubmit;
              return [_c('Form', {
                attrs: {
                  "type": "vertical"
                },
                on: {
                  "submit": function ($event) {
                    return handleSubmit(_vm.onSubmit);
                  }
                }
              }, [_c('ValidationProvider', {
                attrs: {
                  "rules": "required|phone",
                  "name": "телефон"
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref3) {
                    var errors = _ref3.errors;
                    return [_c('FormElement', {
                      attrs: {
                        "hint-min-height": "0",
                        "error": errors[0],
                        "data-e2e": "quick-order-form-phone"
                      }
                    }, [_c('InputText', {
                      attrs: {
                        "model-value": _vm.buyOneClick.number,
                        "placeholder": "+7 (ХХХ) ХХХ - ХХ - ХХ",
                        "data-e2e": "quick-order-phone"
                      },
                      on: {
                        "input": _vm.onInput
                      }
                    })], 1)];
                  }
                }], null, true)
              }), _vm._v(" "), _vm.status === 'error' ? _c('ErrorNote', {
                staticClass: "mb-10",
                attrs: {
                  "theme": "reddish",
                  "error": _vm.response
                }
              }) : _vm._e(), _vm._v(" "), _c('div', {
                staticClass: "mb-10"
              }, [_vm.submited ? _c('Button', {
                attrs: {
                  "size": "33",
                  "theme": "submited",
                  "disabled": ""
                }
              }, [_vm._v("\n                Заявка отправлена\n              ")]) : _vm.status === 'loading' ? _c('Button', {
                attrs: {
                  "size": "33",
                  "theme": "red",
                  "loading": ""
                }
              }) : !_vm.isFeedbackBtnEnabled ? _c('Button', {
                attrs: {
                  "size": "33",
                  "disabled": ""
                }
              }, [_vm._v("\n                Отправить заявку\n              ")]) : _c('Button', {
                attrs: {
                  "size": "33",
                  "data-e2e": "quick-order-submit"
                }
              }, [_vm._v("\n                Отправить заявку\n              ")])], 1), _vm._v(" "), _c('div', {
                staticClass: "quick-order__info"
              }, [_c('Checkbox', {
                attrs: {
                  "checked": _vm.isFeedbackBtnEnabled
                },
                on: {
                  "change": function ($event) {
                    _vm.isFeedbackBtnEnabled = $event;
                  }
                }
              }, [_vm._v("\n                Согласен на\n                "), _c('nuxt-link', {
                staticClass: "link",
                attrs: {
                  "to": "/about/personal-information/"
                },
                nativeOn: {
                  "click": function ($event) {
                    return _vm.close.apply(null, arguments);
                  }
                }
              }, [_vm._v("\n                  обработку персональных данных\n                ")]), _vm._v("\n                в соответствии с\n                "), _c('nuxt-link', {
                staticClass: "link",
                attrs: {
                  "to": "/privacy/"
                },
                nativeOn: {
                  "click": function ($event) {
                    return _vm.close.apply(null, arguments);
                  }
                }
              }, [_vm._v("\n                  политикой конфиденциальности\n                ")]), _vm._v("\n                и\n                "), _c('nuxt-link', {
                staticClass: "link",
                attrs: {
                  "to": "/about/terms-of-use/"
                },
                nativeOn: {
                  "click": function ($event) {
                    return _vm.close.apply(null, arguments);
                  }
                }
              }, [_vm._v("\n                  пользовательским соглашением\n                ")])], 1)], 1)], 1)];
            }
          }], null, true)
        })], 1)])];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }